<template>
  <q-layout view="hHh lpR fFf">
    <SignOutButton class="signout-button" />

    <div :class="{ blur: disableUserFunctionality }" style="height: 100%">
      <InitialLoadingScreen v-if="CommonHelper.loadingQuerySearch.value"></InitialLoadingScreen>
      <q-layout view="hHh Lpr lff">
        <q-drawer
          v-model="drawerLeft"
          side="left"
          :width="500"
          :breakpoint="1000"
          class="drawerContentHeight"
          style="margin-top: 40px; padding: 0px 25px"
        >
          <q-scroll-area class="fit">
            <div align="right" class="q-mr-lg" v-if="$q.screen.width <= 1000">
              <q-btn icon="close" flat round dense class="circle-btn" @click="closeSidebar()" aria-label="Close" />
            </div>
            <div v-show="sideBarMode === 'singularSearch' || sideBarMode === 'advancedSearch'">
              <div class="search-bar; q-px-md">
                <div class="q-pt-md">
                  <div v-show="sideBarMode === 'singularSearch'">
                    <p
                      style="
                        font-size: 24px;
                        font-weight: bold;
                        display: inline-block;
                        vertical-align: middle;
                      "
                    >
                      Singular Search
                    </p>
                    <q-btn
                      flat
                      no-caps
                      label="Advanced Search"
                      @click="setSideBarMode('advancedSearch')"
                      class="action-button"
                      style="
                        float: right;
                        display: inline-block;
                        vertical-align: middle;
                      "
                    />
                  </div>
                  <div v-show="sideBarMode === 'advancedSearch'">
                    <p
                      style="
                        font-size: 24px;
                        font-weight: bold;
                        display: inline-block;
                        vertical-align: middle;
                      "
                    >
                      Advanced Search
                    </p>
                    <q-btn
                      flat
                      no-caps
                      label="Singular Search"
                      @click="setSideBarMode('singularSearch')"
                      class="action-button"
                      style="
                        float: right;
                        display: inline-block;
                        vertical-align: middle;
                      "
                    />
                  </div>
                </div>
                <div style="padding-bottom: 24px">
                  <q-select
                    filled
                    label="Scopes"
                    style="width: 100%; margin-bottom: 36px"
                    class="multiSelectScope"
                    v-model="CommonHelper.selectedSearchScopeOptions.value"
                    :options="searchScopeOptions"
                    use-input
                    multiple
                    input-debounce="0"
                    @filter="filterScopes"
                    :disable="uploadContainerDisableUpload"
                  />
                  <hr
                    style="
                      width: 100%;
                      margin-left: 0px;
                      margin-right: 0px;
                      color: #e9e9e9;
                    "
                  />
                </div>
                <div>
                  <SingularSearchContainer
                    v-show="sideBarMode === 'singularSearch'"
                    :scopeFields="scopeFields"
                  />
                </div>
              </div>

              <div>
                <AdvancedSearchContainer
                  v-show="sideBarMode === 'advancedSearch'"
                  @setSideBarMode="setSideBarMode"
                  :scopeFields="scopeFields"
                />
              </div>
            </div>

            <div v-show="sideBarMode === 'upload' || sideBarMode === 'editMetadata' || sideBarMode === 'uploadFolders' || sideBarMode === 'editMetadataFolders'">
              <div class="search-bar; q-px-md">
                <div class="q-pt-md">
                  <UploadContainer
                    @setSideBarMode="setSideBarMode"
                    :searchScopeOptionsArray="searchScopeOptionsArray"
                    :userUserGroupAccessAccessLevel="userUserGroupAccessAccessLevel"
                    :userUploadAccessLevel="userUploadAccessLevel"
                    :userEditAccessLevel="userEditAccessLevel"
                    :currentUserUID="currentUserUID"
                    :ipAddress="ipAddress"
                    :sideBarMode="sideBarMode"
                    :metadata="metadata"
                    :foldersTable="foldersTable"
                    :filePreview="filePreview"
                    ref="uploadContainer"
                  />
                </div>
              </div>
            </div>
          </q-scroll-area>
        </q-drawer>

        <q-page-container style="width: 100%; height: 100%">
          <q-page style="width: 100%; height: 100%; padding: 0 5em 0">
            <q-btn
              @click="setSideBarMode(searchBtnMode)"
              label="Search"
              class="sidebar-button"
              text-color="white"
              :disabled="disableUserFunctionality"
            />
            <q-btn
              @click="setSideBarMode(uploadBtnMode)"
              label="Upload"
              class="sidebar-button-upload"
              text-color="white"
              v-if="userUploadAccessLevel"
              :disabled="disableUserFunctionality"
            />

            <div>
              <div style="display: inline-block; width: 100%; margin-top: 47px;">
                <HomeLogo />
                <div
                  style="
                    display: inline-block;
                    position: relative;
                    float: right;
                  "
                >
                  <div style="display: inline-block">
                    <q-select
                      filled
                      label="Scopes"
                      style="margin-right: 30px; margin-bottom: 8px;"
                      class="multiSelectScope dynamicMultiSelectScope"
                      v-model="CommonHelper.selectedSearchScopeOptions.value"
                      :options="searchScopeOptions"
                      use-input
                      multiple
                      input-debounce="0"
                      @filter="filterScopes"
                      :disable="disableUserFunctionality || uploadContainerDisableUpload"
                      v-show="!drawerLeft"
                    />
                  </div>
                  <q-btn
                    class="search-button"
                    no-caps
                    unelevated
                    text-color="white"
                    label="Search"
                    @click="setSideBarMode(searchBtnMode)"
                    :disabled="disableUserFunctionality"
                  />
                  <q-btn
                    class="upload-button"
                    no-caps
                    unelevated
                    text-color="white"
                    label="Upload"
                    v-if="userUploadAccessLevel"
                    @click="setSideBarMode(uploadBtnMode)"
                    :disabled="disableUserFunctionality"
                  />
                  <q-btn
                    class="folders-button"
                    no-caps
                    unelevated
                    text-color="white"
                    label="Folders"
                    @click="setSideBarMode('folders')"
                    :disabled="disableUserFunctionality"
                  />
                  <q-btn
                    @click="handleAdmin"
                    label="Admin"
                    unelevated
                    no-caps
                    text-color="black"
                    class="admin-button"
                    v-if="userAdminAccessLevel"
                    :disabled="disableUserFunctionality"
                  />
                  <HelpButtonAndDarkMode
                    @toggleDarkMode="toggleDarkMode"
                    :disableUserFunctionality="disableUserFunctionality"
                    :userAdminAccessLevel="userAdminAccessLevel"
                    :userEditAccessLevel="userEditAccessLevel"
                    :userUploadAccessLevel="userUploadAccessLevel"
                    :feedbackForm="feedbackForm"
                    :changePassword="changePassword"
                    helpScreen="searchEngineContent"
                  />
                </div>
              </div>

              <div style="height: 100%; margin-top: 8px;">
                <ResultsTable
                  id="agGridMainTable"
                  @editMetadata="editMetadata"
                  @setSideBarMode="setSideBarMode"
                  :sideBarMode="sideBarMode"
                  :scopeFields="scopeFields"
                  :userEditAccessLevel="userEditAccessLevel"
                  :userDeleteAccessLevel="userDeleteAccessLevel"
                  :foldersTable="foldersTable"
                  :resultTree="resultTree"
                  :filePreview="filePreview"
                  :fileDelete="fileDelete"
                  :fileVersionAdmin="fileVersionAdmin"
                  v-show="sideBarMode !== 'folders' && sideBarMode !== 'uploadFolders' && sideBarMode !== 'editMetadataFolders'"
                  ref="resultTable"
                />

                <FoldersTable
                  @editMetadata="editMetadata"
                  @setSideBarMode="setSideBarMode"
                  :uploadContainer="uploadContainer"
                  :resultTree="resultTree"
                  :filePreview="filePreview"
                  :fileDelete="fileDelete"
                  :fileVersionAdmin="fileVersionAdmin"
                  v-show="sideBarMode === 'folders' || sideBarMode === 'uploadFolders' || sideBarMode === 'editMetadataFolders'"
                  ref="foldersTable"
                />

                <ResultsTree
                  ref="resultTree"
                />

                <FilePreview
                  :sideBarMode="sideBarMode"
                  :resultTable="resultTable"
                  :foldersTable="foldersTable"
                  :darkMode="darkMode"
                  ref="filePreview"
                />

                <FileDelete
                  :currentUserUID="currentUserUID"
                  :ipAddress="ipAddress"
                  :uploadContainer="uploadContainer"
                  :foldersTable="foldersTable"
                  ref="fileDelete"
                />

                <FileVersionAdmin
                  :currentUserUID="currentUserUID"
                  :ipAddress="ipAddress"
                  :userDeleteAccessLevel="userDeleteAccessLevel"
                  :filePreview="filePreview"
                  ref="fileVersionAdmin"
                />
              </div>
            </div>
          </q-page>
        </q-page-container>
        <AppFooter />
      </q-layout>

      <FeedbackForm
        :disableUserFunctionality="disableUserFunctionality"
        ref="feedbackForm"
      />

      <ChangePassword
        ref="changePassword"
      />
    </div>
  </q-layout>
</template>

<script>
import AdvancedSearchContainer from "./AdvancedSearchContainer";
import SingularSearchContainer from "./SingularSearchContainer.vue";
import UploadContainer from "./UploadContainer.vue";
import InitialLoadingScreen from "./InitialLoadingScreen.vue";
import SignOutButton from "../admin/SignOutButton.vue";
import HomeLogo from "../layout/HomeLogo.vue";
import HelpButtonAndDarkMode from "../helpTour/HelpButtonDarkMode.vue";
import FeedbackForm from "../helpTour/FeedbackForm.vue";
import ChangePassword from "../helpTour/ChangePassword.vue";
import FileDelete from "../search-result/FileDelete.vue";
import FilePreview from "../search-result/FilePreview.vue";
import FileVersionAdmin from "../search-result/FileVersionAdmin.vue";
import FoldersTable from "../search-result/FoldersTable.vue";
import ResultsTable from "../search-result/ResultsTable.vue";
import ResultsTree from "../search-result/ResultsTree.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import AuthHelper from "../helper/AuthHelper.js"
import CommonHelper from "../helper/CommonHelper.js";
import router from "../../router";
import AppFooter from "../layout/AppFooter.vue";
import { useQuasar } from "quasar";

export default {
  name: "SearchEngineContent",
  components: {
    AdvancedSearchContainer,
    SingularSearchContainer,
    UploadContainer,
    FileDelete,
    FilePreview,
    FileVersionAdmin,
    FoldersTable,
    ResultsTable,
    ResultsTree,
    InitialLoadingScreen,
    SignOutButton,
    HomeLogo,
    HelpButtonAndDarkMode,
    FeedbackForm,
    ChangePassword,
    AppFooter
  },
  setup() {
    const disableUserFunctionality = ref(false);
    const feedbackForm = ref();
    const changePassword = ref();
    const darkMode = ref();
    const uploadContainer = ref();
    const resultTable = ref();
    const foldersTable = ref();
    const resultTree = ref();
    const filePreview = ref();
    const fileDelete = ref();
    const fileVersionAdmin = ref();
    const currentUserUID = ref();
    const ipAddress = ref();
    const userUserGroupAccessAccessLevel = ref(false);
    const userUploadAccessLevel = ref(false);
    const userEditAccessLevel = ref(false);
    const userDeleteAccessLevel = ref(false);
    const userAdminAccessLevel = ref(false);

    const searchScopeOptionsArray = ref([]);
    const searchScopeOptions = ref([]);

    watch(CommonHelper.selectedSearchScopeOptionsLength, (currentLength) => {
      if (sideBarMode.value === "upload" || sideBarMode.value === "uploadFolders") {
        let uploadScopeOption = CommonHelper.selectedSearchScopeOptions.value.find((searchScopeOption) => {
          if (CommonHelper.checkScopeUpload(searchScopeOption)) {
            return searchScopeOption;
          }
        });

        if (!uploadScopeOption) {
          // When Upload form is open and selectedSearchScopeOptions does not include an upload scope, then this will force close the form
          if (sideBarMode.value === "uploadFolders") {
            setSideBarMode("folders");
          } else {
            setSideBarMode("uploadHidden");
          }
        }
      } else if (sideBarMode.value === "editMetadata") {
        // When Edit Metadata form is open and the scope is changed, then this will force close the form
        setSideBarMode("singularSearchHidden");
      } else if (sideBarMode.value === "editMetadataFolders") {
        // When Edit Metadata form is open and the scope is changed, then this will force close the form
        setSideBarMode("folders");
      }

      if (currentLength == 0 && searchBtnMode.value.includes("Hidden")) {
        // When any form is open and selectedSearchScopeOptions is empty, then this will force close the form
        setSideBarMode(searchBtnMode.value);
      }
    });

    /*
     * Filter function for the Scopes dropdown
     */
    function filterScopes(val, update) {
      CommonHelper.filterOptions(val, update, searchScopeOptions, searchScopeOptionsArray.value);
    }

    const scopeFields = computed(() => {
      return CommonHelper.getScopeFields(CommonHelper.selectedSearchScopeOptions.value);
    });

    const sideBarMode = ref("singularSearchHidden");

    const drawerLeft = computed({
      get() {
        return !(sideBarMode.value === "singularSearchHidden" || sideBarMode.value === "advancedSearchHidden" || sideBarMode.value === "uploadHidden" || sideBarMode.value === "folders");
      },
      set(sidebarStatus) {
        if (!sidebarStatus) {
          closeSidebar();
        }
      }
    });

    const searchBtnMode = computed(() => {
      var nextMode;
      switch (sideBarMode.value) {
        case "singularSearch":
          nextMode = "singularSearchHidden";
          break;
        case "singularSearchHidden":
          nextMode = "singularSearch";
          break;
        case "advancedSearch":
          nextMode = "advancedSearchHidden";
          break;
        case "advancedSearchHidden":
          nextMode = "advancedSearch";
          break;
        default:
          nextMode = "singularSearch";
          break;
      }
      return nextMode;
    })

    const uploadBtnMode = computed(() => {
      var nextMode;
      switch (sideBarMode.value) {
        case "upload":
          nextMode = "uploadHidden";
          break;
        case "uploadFolders":
          nextMode = "folders";
          break;
        case "editMetadataFolders":
        case "folders":
          nextMode = "uploadFolders";
          break;
        default:
          nextMode = "upload";
          break;
      }
      return nextMode;
    })

    function closeSidebar() {
      if (sideBarMode.value === "singularSearch" || sideBarMode.value === "advancedSearch") {
        setSideBarMode(searchBtnMode.value);
      } else if (sideBarMode.value === "upload") {
        setSideBarMode(uploadBtnMode.value);
      }
    }

    watch([drawerLeft, CommonHelper.displayHiddenColumns], () => {
      resultTable.value.reSize();
    });

    const setFileTypeOptionsParameter = computed(() => {
      return (sideBarMode.value === "upload" || sideBarMode.value === "editMetadata" || sideBarMode.value === "uploadFolders" || sideBarMode.value === "editMetadataFolders") ?
        uploadContainer.value.uploadScope : CommonHelper.selectedSearchScopeOptions.value;
    });

    watch(setFileTypeOptionsParameter, () => {
      CommonHelper.setFileTypeOptions(setFileTypeOptionsParameter.value);
    });


    function toggleDarkMode(value) {
      darkMode.value = value;
    }

    // Sets the color of 'Search', 'Upload', 'Folders', and 'Admin' buttons
    watch([sideBarMode, darkMode], () => {
      const searchbuttonActive = sideBarMode.value === "advancedSearch" || sideBarMode.value === "advancedSearchHidden" ||
                                 sideBarMode.value === "singularSearch" || sideBarMode.value === "singularSearchHidden";
      document.documentElement.style.setProperty("--search-btn", CommonHelper.getHeaderButtonColor(searchbuttonActive, darkMode.value));
      document.documentElement.style.setProperty("--search-tab-btn", searchbuttonActive ? "#0067C1" : "#707070");

      const uploadbuttonActive = sideBarMode.value === "upload" || sideBarMode.value === "uploadHidden" || sideBarMode.value === "uploadFolders";
      document.documentElement.style.setProperty("--upload-btn", CommonHelper.getHeaderButtonColor(uploadbuttonActive, darkMode.value));
      document.documentElement.style.setProperty("--upload-tab-btn", uploadbuttonActive ? "#0067C1" : "#707070");

      const foldersbuttonActive = sideBarMode.value === "folders";
      document.documentElement.style.setProperty("--folders-btn", CommonHelper.getHeaderButtonColor(foldersbuttonActive, darkMode.value));

      document.documentElement.style.setProperty("--admin-btn", darkMode.value ? "#FFFFFF" : "#000000");
    })

    const metadata = ref(null);

    /*
     * Sets up the "editMetadata" form
     */
    function editMetadata(newMetadata) {
      CommonHelper.updateStoredFileLatest(newMetadata.id, false);  // fileLatest is updated just in case the user wants to replace the file

      metadata.value = newMetadata;

      if (sideBarMode.value === "folders" || sideBarMode.value === "uploadFolders" || sideBarMode.value === "editMetadataFolders") {
        setSideBarMode("editMetadataFolders");
      } else {
        setSideBarMode("editMetadata");
      }
    }

   /* Handles the display of the side bar.
    * 
    * 'mode' argument can be set to one of the following possible mode:
    *     advancedSearch, advancedSearchHidden, singularSearch, singularSearchHidden, upload, uploadHidden, uploadFolders, editMetadata, editMetadataFolders
    */
    function setSideBarMode(mode) {
      sideBarMode.value = mode;

      if (mode === "singularSearch" || mode === "advancedSearch") {
        if (CommonHelper.selectedSearchScopeOptions.value.length === 0) {
          CommonHelper.addSelectedSearchScopeOption(searchScopeOptionsArray.value[0]);
        }
      } else if (mode === "upload" || mode === "uploadFolders") {
        defaultUploadScope();
      }
    }

    // Defaults to first upload scope if current scope is non-upload
    function defaultUploadScope() {
      let uploadScopeOption = CommonHelper.selectedSearchScopeOptions.value.find((searchScopeOption) => {
        if (CommonHelper.checkScopeUpload(searchScopeOption)) {
          return searchScopeOption;
        }
      });

      if (!uploadScopeOption) {
        uploadScopeOption = searchScopeOptionsArray.value.find((searchScopeOption) => {
          if (CommonHelper.checkScopeUpload(searchScopeOption)) {
            return searchScopeOption;
          }
        });

        CommonHelper.addSelectedSearchScopeOption(uploadScopeOption);
      }
    }

    function handleAdmin() {
      router.push("/admin");
    }

    const $q = useQuasar();

    onBeforeMount(async () => {
      CommonHelper.loadingQuerySearch.value = true;
      const userData = await AuthHelper.getCurrentUserData(true, true);
      await CommonHelper.setCurrentUserData(userData);
      currentUserUID.value = userData.uid;
      ipAddress.value = await AuthHelper.getIpAddress();
      searchScopeOptionsArray.value = userData.scopesAccess; 

      if (isAccessAuthorized()) {
        CommonHelper.getZipFileData();
        CommonHelper.getIndexCounts();
        CommonHelper.retrieveFirestoreIndex(searchScopeOptionsArray.value);

        const urlParams = new URLSearchParams(window.location.search);
        const searchScopeParam = urlParams.get("searchScope");

        if (searchScopeParam !== null && searchScopeParam !== "") {
          const searchScopeParamArray = searchScopeParam.split(",");

          searchScopeParamArray.forEach((searchScope) => {
            if ((searchScopeOptionsArray.value.includes(searchScope))) {
              CommonHelper.addSelectedSearchScopeOption(searchScope);
            }
          })
        }

        if (CommonHelper.selectedSearchScopeOptions.value.length === 0) {
          CommonHelper.selectedSearchScopeOptions.value = searchScopeOptionsArray.value;
        }

        CommonHelper.setFileTypeOptions(CommonHelper.selectedSearchScopeOptions.value);

        const currentUserAccessLevel = userData.accessLevel;

        userUserGroupAccessAccessLevel.value = currentUserAccessLevel.includes("User_Group_Access");
        userUploadAccessLevel.value = currentUserAccessLevel.includes("Upload");
        userEditAccessLevel.value = currentUserAccessLevel.includes("Edit");
        userDeleteAccessLevel.value = currentUserAccessLevel.includes("Delete");
        userAdminAccessLevel.value = currentUserAccessLevel.includes("Admin");

        // set userUploadAccessLevel to false if user does not have access to upload scopes
        if (userUploadAccessLevel.value) {
          var uploadScopeOption = searchScopeOptionsArray.value.find((searchScopeOption) => {
            if (CommonHelper.checkScopeUpload(searchScopeOption)) {
              return searchScopeOption;
            }
          });

          if (!uploadScopeOption) {
            userUploadAccessLevel.value = false;
          }
        }

        // set userEditAccessLevel to false if user does not have access to edit scopes
        if (userEditAccessLevel.value) {
          var editScopeOption = searchScopeOptionsArray.value.find((searchScopeOption) => {
            if (CommonHelper.checkScopeEdit(searchScopeOption)) {
              return searchScopeOption;
            }
          });

          if (!editScopeOption) {
            userEditAccessLevel.value = false;
          }
        }

        await CommonHelper.checkLoadingQuerySearch();

        if (CommonHelper.querySearchType.value === "" || CommonHelper.querySearchType.value.includes("error")) {
          const folderParam = urlParams.get("folder");

          if (folderParam) {
            setSideBarMode("folders");
          }
        }
      } else {
        disableUserFunctionality.value = true;
        document.documentElement.style.setProperty("--sign-out-button-z-index", "3000");
        feedbackForm.value.displayFeedbackForm();
      }
    });

    /*
     * Returns whether or not access is authorized
     */
    function isAccessAuthorized() {
      return searchScopeOptionsArray.value.length > 0;
    }

    const uploadContainerDisableUpload = computed(() => {
      let isDisableUpload = false;

      if (uploadContainer.value) {
        if (uploadContainer.value.disableUpload) {
          isDisableUpload = true;
        }
      }

      return isDisableUpload;
    });


    return {
      //helper
      CommonHelper,

      //variable properties
      searchScopeOptionsArray,
      searchScopeOptions,
      scopeFields,
      darkMode,
      uploadContainer,
      resultTable,
      foldersTable,
      resultTree,
      filePreview,
      fileDelete,
      fileVersionAdmin,
      drawerLeft,
      disableUserFunctionality,
      feedbackForm,
      changePassword,
      sideBarMode,
      metadata,
      currentUserUID,
      ipAddress,
      userUserGroupAccessAccessLevel,
      userUploadAccessLevel,
      userEditAccessLevel,
      userDeleteAccessLevel,
      userAdminAccessLevel,
      searchBtnMode,
      uploadBtnMode,
      uploadContainerDisableUpload,

      //functions
      filterScopes,
      closeSidebar,
      editMetadata,
      setSideBarMode,
      InitialLoadingScreen,
      HelpButtonAndDarkMode,
      toggleDarkMode,
      handleAdmin,
    };
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
.search-bar {
  display: flex;
  justify-content: center;
  align-items: center;

  .q-btn {
    margin-left: 0.8rem;
  }
}

.admin-button {
  color: var(--admin-btn) !important;
  font-size: 20px;
}
</style>

<style type="text/scss" lang="scss">
:root {
  --search-tab-btn: #0067c1;
  --upload-tab-btn: #707070;
  --search-btn: #0067c1;
  --upload-btn: #707070;
  --folders-btn: #707070;
}

.search-button {
  color: var(--search-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.upload-button {
  color: var(--upload-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.folders-button {
  color: var(--folders-btn) !important;
  font-size: 20px;
  margin-right: 8px;
}

.sidebar-button {
  position: absolute;
  transform: rotate(90deg);
  top: 136px;
  left: -31px;
  background: var(--search-tab-btn) !important;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px !important;
  padding-right: 20px;
  padding-left: 20px;
}

.sidebar-button-upload {
  position: absolute;
  transform: rotate(90deg);
  top: 256px;
  left: -31px;
  background: var(--upload-tab-btn) !important;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px !important;
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.multiSelectScope {
  width: 500px;

  .q-field__inner .q-field__control .q-field__control-container .q-field__native
  {
      margin-bottom: 12px;
      max-height: 35px;
      min-height: unset;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 12px;
  
      // Scroll bar CSS (scrollbar-) for Firefox browser
      scrollbar-color: #808080 white;
      scrollbar-width: thin;
  }

  // Scroll bar CSS (-webkit-scrollbar) for Chrome, Edge, and Safari browser
  *::-webkit-scrollbar {
    width: 7px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #808080;
  }

  *::-webkit-scrollbar-track {
    background: white;
  }
}

// The width of the multi-select scope will change to 320px when resolution is 1680 x 1050 or smaller.
.dynamicMultiSelectScope {
  @media screen and (max-height: 1050px) and (max-width: 1680px) {
    width: 265px;
  }
}

.drawerContentHeight {
  height: 85% !important;
}
</style>
